import { Link } from "react-router-dom";
import { useUserXp } from "../../hooks/useUserXp";
import styles from "./header.module.scss";
import { useTranslation } from "react-i18next";
import { useLocalizedPath } from "../../i18n/localizedPath";
import TurtleIcon from "../AssistantWidget/TurtleIcon";

function LevelStageIcon({ level }: { level: number }) {
    if (level <= 10) {
        return <span className={styles.levelStageIcon} data-level-stage="egg" aria-hidden="true">🥚</span>;
    }

    if (level <= 15) {
        return <span className={styles.levelStageIcon} data-level-stage="hatching-egg" aria-hidden="true">🐣</span>;
    }

    return <span className={styles.levelStageIcon} data-level-stage="baby-turtle" aria-hidden="true"><TurtleIcon size={18} animated={false} /></span>;
}

// The link is the 44px-tall hit area; the visible chip (~28px) lives inside it
// so the touch target stays comfortable without a chunky pill. Below 380px the
// chip reads "Lv N" instead of "Level N" (both are in the DOM, CSS picks one -
// the link's aria-label is what assistive tech announces either way).
export default function LevelBadge() {
    const { t } = useTranslation("common");
    const lp = useLocalizedPath();
    const { status, progress, hasProgress } = useUserXp();
    if (status === "signed-out") return null;
    const hasLevel = hasProgress;
    return <Link to={lp("/profile")} className={styles.levelBadge}
        aria-label={hasLevel ? t("levelBadge.withLevel", { level: progress.level, xp: progress.xp }) : t("levelBadge.withoutLevel")}
        aria-busy={status === "loading" ? "true" : undefined}
        title={hasLevel ? `${progress.xp} XP` : undefined}>
        <span className={`${styles.levelChip}${hasLevel ? ` ${styles.levelBadgeEarned}` : ""}`}>
            {hasLevel ? (
                <>
                    <LevelStageIcon level={progress.level} />
                    <span className={styles.levelLong}>{t("levelBadge.levelLong", { level: progress.level })}</span>
                    <span className={styles.levelShort}>{t("levelBadge.levelShort", { level: progress.level })}</span>
                </>
            ) : (
                <span>{t("levelBadge.yourLevel")}</span>
            )}
            {status === "loading" && <span className={styles.levelSpinner} aria-hidden="true" />}
        </span>
    </Link>;
}
